import { render, staticRenderFns } from "./BasicInformationCompany.vue?vue&type=template&id=210cf1bf&scoped=true"
import script from "./BasicInformationCompany.vue?vue&type=script&lang=js"
export * from "./BasicInformationCompany.vue?vue&type=script&lang=js"
import style0 from "./BasicInformationCompany.vue?vue&type=style&index=0&id=210cf1bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210cf1bf",
  null
  
)

export default component.exports